import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import Style from "./style"
import backIcon from "./asset/back.svg"
import defaultImg from "./asset/default.jpg"

import ImageModal from "widget/ImageModal"

const Banner = ({ imgList }) => {
    const navigate = useNavigate()

    const mouseDownCheckRef = useRef(false)
    const dragCheckRef = useRef(false)
    const [imgListIndex, setImgListIndex] = useState(0)
    const [expandImgSrc, setExpandImgSrc] = useState(null)

    const sliderConfig = {
        "dots": false,
        "arrows": false,
        "infinite": imgList?.length == 1 ? false : true,   // NOTE: 이미지가 1개일 때 true를 주면 버그 발생
        "autoplay": true,
        "pauseOnHover": true,
        "pauseOnFocus": true,
        "speed": 700,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "beforeChange": (currentIndex, nextIndex) => setImgListIndex(nextIndex)
    }

    return (
        <>
            {expandImgSrc && <ImageModal src={expandImgSrc} closeEvent={() => setExpandImgSrc(null)} />}

            <Style.BannerDiv>

                {imgList?.length > 0
                    ? <Slider {...sliderConfig}>
                        {imgList?.map(elem =>
                            <Style.BannerElem>
                                <Style.BackgroundImg src={elem}
                                    onClick={() => !dragCheckRef.current && setExpandImgSrc(elem)}
                                    onMouseDown={() => mouseDownCheckRef.current = true}
                                    onMouseMove={() => mouseDownCheckRef.current ? dragCheckRef.current = true : dragCheckRef.current = false}
                                    onMouseUp={() => mouseDownCheckRef.current = false}
                                />
                            </Style.BannerElem>
                        )}
                    </Slider>
                    : <Style.BackgroundImg src={defaultImg} />
                }

                <Style.BackBtn onClick={() => navigate(-1)}><img src={backIcon} /></Style.BackBtn>

                {imgList?.length > 0 &&
                    <Style.PageDiv>
                        <p>{imgListIndex + 1}<span>/</span>{imgList?.length}</p>
                    </Style.PageDiv>
                }

            </Style.BannerDiv >
        </>
    )
}

export default Banner